import React from 'react';
import { Reveal } from './Reveal';
import { problems } from '../data/hero';
export function Problems() {
  return <section className="w-full bg-surface px-4 py-20 text-navy sm:py-24" data-id="element-188" data-mp="36wspdzdw92qt">
      <div className="mx-auto max-w-3xl" data-id="element-189" data-mp="324j1eowcacr6">
        <Reveal className="text-center" data-id="element-190" data-mp="323hr4mn5duai">
          <h2 className="font-serif text-4xl leading-tight sm:text-5xl" data-id="element-191" data-mp="2y3fpgdhex0v8">
            💔 Quante volte ancora <span className="text-amber" data-id="element-192" data-mp="2t4cszhfi02yv">ripeterai la stessa storia ?</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-193" data-mp="2t2038i3i0ob9">
            Se stai lavorando su te stesso, probabilmente hai vissuto ciascuno di questi momenti :
          </p>
        </Reveal>
        <ul className="mt-10 space-y-3" data-id="element-194" data-mp="2j6ot6d31c59u">
          {problems.map((problem, index) => <Reveal key={problem} delay={index * 0.035} data-id="element-195" data-mp="2f661qk521186" data-mpi={index}>
              <li className="flex gap-3 rounded-xl border border-navy/10 bg-mist p-5 text-sm leading-relaxed text-slate shadow-premium sm:text-base" data-id="element-196" data-mp="hek02y9sv1xj">
                <span aria-hidden="true" className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-amber/60 text-xs text-amber" data-id="element-197" data-mp="ddzztltxji76">
                  ✕
                </span>
                {problem}
              </li>
            </Reveal>)}
        </ul>
        <Reveal data-id="element-198" data-mp="2zrid3qt1h3d5">
          <p className="mt-10 text-center font-serif text-2xl italic text-amber sm:text-3xl" data-id="element-199" data-mp="2zr0amcfs9sws">
            «&nbsp;Non è un fallimento personale. È uno schema generazionale. E ha una mappa.&nbsp;»
          </p>
        </Reveal>
      </div>
    </section>;
}